// 子任务确定课题路由

export default [
  // 账号获取
  {
    path: 'acountPassword',
    name: 'acountPassword',
    component: () =>
    import(/* webpackChunkName: "AcountPassword" */ '@/components/sub-task/acount-password/acount-password')
  },
  // 信息分发
  {
    path: 'infoDistribute',
    name: 'infoDistribute',
    component: () =>
    import(/* webpackChunkName: "AcountPassword" */ '@/components/sub-task/acount-password/info-distribute')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/sub-task/acount-password.js